import React from 'react';

import { Navigate } from 'react-router-dom';

import { useFeature } from '../hooks';

import type { Feature } from '../hooks';

// A tenant without the feature never sees the page: back to Statements.
const FeatureRoute: React.FC<{
	feature: Feature;
	children: React.ReactNode;
}> = ({ feature, children }) =>
	useFeature(feature) ? <>{children}</> : <Navigate to="/" replace />;

export default FeatureRoute;
